// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"a7ff0356","125":"7f08fc6d","162":"1c0ad5f3","165":"59fb19aa","217":"1d4b9d08","405":"4bee96a9","453":"9e1e7267","563":"2c87c8a2","574":"a8ad9398","609":"45fc1fe6","639":"60ada561","642":"08148c8b","685":"1e9e60dc"}[chunkId] + ".chunk.js";
};